import { registerMfModule } from 'src/store/base';
import account from './account';
import ad from './ad';
import audience from './audience';
import bc from './bc';
import brand from './brand';
import campaign from './campaign';
import catalog from './catalog';
import contract from './contract';
import creative from './creative';
import dashboard from './dashboard';
import library from './library';
import notify from './notify';
import payment from './payment';
import perf from './perf';
import report from './report';
import smbSupport from './smb-support';
import tanblock from './tanblock';
import teaAnalyze from './tea-analyze';
import operationLog from './tool';
import transaction from './transaction';
import user from './user';
import rf from './rf';
import qualification from './qualification';
import efficientTool from './efficient-tool';
import diagnosis from './diagnosis';
import shop from './shop';
import commonTcc from './common-tcc';
import popupStatus from './popup-status';

export default {
  ad,
  account,
  audience,
  campaign,
  ...registerMfModule([creative]),
  brand,
  dashboard,
  operationLog,
  ...registerMfModule([library]),
  notify,
  payment,
  transaction,
  perf,
  report,
  teaAnalyze,
  tanblock,
  user,
  contract,
  smbSupport,
  catalog,
  bc,
  rf,
  qualification,
  efficientTool,
  diagnosis,
  shop,
  commonTcc,
  popupStatus,
};
